export default __webpack_public_path__ + "static/media/avatar_tommy_pyper6.b3dad87e.mp3";